import { Directive, ElementRef, Inject, HostListener } from '@angular/core';

@Directive({
  selector: '[itaxToggleCheckbox]'
})
export class ToggleCheckboxDirective {

  constructor(@Inject(ElementRef) private el: ElementRef) { }

  @HostListener('click', ['$event']) onClick() {
    const input = this.el.nativeElement.querySelector('input');
    if (input) {
      input.click();
    }
  }
}
